/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) In Range Icon component.
 */
export const SystemInRangeIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M8.05639 5.32178H1.5C1.22386 5.32178 1 5.54563 1 5.82178V10.5059C1 10.7821 1.22386 11.0059 1.5 11.0059H8.05639C8.33253 11.0059 8.55639 10.7821 8.55639 10.5059V5.82178C8.55639 5.54563 8.33253 5.32178 8.05639 5.32178Z' fill={iconColor} />
      <path d='M9.91717 10.7328C10.4877 10.5869 10.993 10.2543 11.3528 9.78812C11.7126 9.32191 11.9061 8.74878 11.9027 8.15989C11.8992 7.57101 11.699 7.0002 11.3338 6.53822C10.9686 6.07625 10.4594 5.74963 9.88721 5.61035' stroke={iconColor} strokeMiterlimit='10' />
      <path d='M10.779 12.3427C11.7061 12.1024 12.5265 11.5596 13.1102 10.8003C13.6939 10.041 14.0077 9.10868 14.0016 8.15096C13.9956 7.19324 13.6702 6.26491 13.077 5.51302C12.4838 4.76113 11.6566 4.22867 10.7266 4' stroke={iconColor} strokeMiterlimit='10' />
    </svg>
  );
};

export default SystemInRangeIcon;
